export default "__VITE_ASSET__Bri8LVSE__"